import { BAOCustomElement } from '@bao/custom-element'
import { Cart } from '@bao/cart'
import { sectionRenderer } from '@bao/section-rendering'

class ProductCardForm extends BAOCustomElement() {
  constructor () {
    super()

    this._loading = false
    this.sections = this.inPushCart
      ? sectionRenderer.pushCartSections
      : this.onCartPage
        ? sectionRenderer.cartSections
        : []
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.handleFormSubmit.bind(this))
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(
        `needs to be wrapped around a product card's <form> element`,
      )
    }
  }

  async handleFormSubmit (event) {
    event.preventDefault()
    await this.addToCart()
  }

  async addToCart () {
    return Cart.addItemFromForm(this.form, {
      sections: this.mappedSections,
    })
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }

  get inPushCart () {
    return document.body.dataset.pageType !== 'cart'
  }

  get onCartPage () {
    return document.body.dataset.pageType === 'cart'
  }

  get mappedSections () {
    return this.sections.map((s) => s.section)
  }
}

if (!customElements.get('product-card-form')) {
  customElements.define('product-card-form', ProductCardForm)
}
